var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7294_919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.16682L15.8334 7.50015M17.645 5.67682C18.0856 5.23634 18.3332 4.63888 18.3333 4.01587C18.3333 3.39285 18.0859 2.79533 17.6454 2.35474C17.205 1.91415 16.6075 1.66658 15.9845 1.6665C15.3615 1.66643 14.764 1.91384 14.3234 2.35432L3.20169 13.4785C3.00821 13.6714 2.86512 13.9089 2.78503 14.1702L1.68419 17.7968C1.66266 17.8689 1.66103 17.9454 1.67949 18.0184C1.69794 18.0913 1.73579 18.1578 1.78902 18.211C1.84225 18.2641 1.90888 18.3019 1.98183 18.3202C2.05477 18.3386 2.13133 18.3368 2.20336 18.3152L5.83086 17.2152C6.09183 17.1358 6.32934 16.9936 6.52253 16.801L17.645 5.67682Z",
    stroke: "#23296F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7294_919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.89e6ed2b.svg";
export { ForwardRef as ReactComponent };